import { RiAddLargeLine } from "@remixicon/react";
import { useTranslate } from "@tolgee/react";
import { type OrderStatusEnum } from "@/config/apiClient.types";
import { getSelectHeaderOptionsText } from "@/helpers/lang/getSelectHeaderOptionsText";
import { useOrders } from "../../queries/useOrders";
import {
  CATEGORY_CONFIG,
  NEW_ORDER_KEY,
  VALID_ORDER_STATUSES,
} from "./useGetAvailableOrdersOptions.constants";
import { type CategoryOption } from "./useGetAvailableOrdersOptions.types";

export const useGetAvailableOrdersOptions = () => {
  const { t } = useTranslate();

  const { useGetOrders } = useOrders();
  const { data: allOrders } = useGetOrders({ currentPage: 0, nbPerPage: 9999 });

  const availableOrders =
    allOrders?.data?.page?.filter((order) =>
      VALID_ORDER_STATUSES.includes(order.status)
    ) ?? [];

  const getSortedOrdersByStatus = (status: OrderStatusEnum) => {
    return (
      availableOrders
        ?.filter((order) => order.status === status)
        .sort((a, b) => a.name.localeCompare(b.name)) ?? []
    );
  };

  const options = [
    {
      id: NEW_ORDER_KEY,
      label: t("order.mediumDetails.stepConfiguration.newOrderSelected"),
      textValue: t("order.mediumDetails.stepConfiguration.newOrder"),
      icon: RiAddLargeLine,
    },
    ...CATEGORY_CONFIG.reduce<CategoryOption[]>((acc, config) => {
      const orders = getSortedOrdersByStatus(config.status);

      if (orders.length > 0) {
        acc.push({
          id: config.key,
          name: getSelectHeaderOptionsText(config.status),
          categoryOptions: orders.map((order) => ({
            id: order.id,
            label: order.name,
            textValue: order.name,
          })),
        });
      }
      return acc;
    }, []),
  ];

  return {
    options,
    availableOrders,
  };
};
